export default __webpack_public_path__ + "static/media/rightVector.0ec136e2.svg";